<template>
    <div >
        <vs-dialog prevent-close class="excel" v-model="active" width="950px" @close="regreshExcel">
            <template #header>
                <h5 class="not-margin">
                    La información se guardará en <strong>{{nombreCodigo}}</strong>
                </h5>
            </template>
            <div class="con-content">
                <md-table>
                    <md-table-row>
                        <md-table-head>Aula</md-table-head>
                        <md-table-head>Docente</md-table-head>
                        <md-table-head>Docente auxiliar</md-table-head>
                        <md-table-head>Hora inicio</md-table-head>
                        <md-table-head>Hora fin</md-table-head>
                        <md-table-head>Días</md-table-head>
                    </md-table-row>

                    <md-table-row 
                        :key="i"
                        v-for="(tr, i) in infoExcel"
                        :data="tr"
                    >
                        <md-table-cell>
                            <p class="mb-0"><small>ID</small></p>
                            <p><strong>{{aula[i]}}</strong></p>
                            <p class="mb-0"><small>NOMBRE</small></p>
                            <div v-for="(option, j) in allAulas[0]" :key="j">
                                <p v-if="aula[i] == option.id"><strong> {{option.nombre}} </strong></p>
                            </div> 
                        </md-table-cell>
                        <md-table-cell>
                            <p class="mb-0"><small>ID</small></p>
                            <p><strong>{{nombre_docente[i]}}</strong></p>
                            <p class="mb-0"><small>NOMBRE</small></p>
                            <div v-for="(option, j) in docentes" :key="j">
                                <p v-if="nombre_docente[i] == option.id"><strong> {{option.text}} </strong></p>
                            </div> 
                        </md-table-cell>
                        <md-table-cell>
                            <p class="mb-0"><small>ID</small></p>
                            <p><strong>{{aux_nombre_docente[i]}}</strong></p>
                            <p class="mb-0"><small>NOMBRE</small></p>
                            <div v-for="(option, j) in docentes" :key="j">
                                <p v-if="aux_nombre_docente[i] == option.id"><strong> {{option.text}} </strong></p>
                            </div>
                        </md-table-cell>
                        <md-table-cell>
                            <p>{{hora_inicio[i]}}</p>
                        </md-table-cell>
                        <md-table-cell>
                            <p>{{hora_fin[i]}}</p>
                        </md-table-cell>
                        <md-table-cell>
                            <div v-for="option in dia[i]" :key="option" class="d-flex">
                                <i class="fas fa-caret-right mr-1"></i><p class="text-capitalize mb-0">{{ option }}</p>
                                <!-- <md-chip   class="mb-1 fontMedium mini-chip col-blue"><strong>  </strong></md-chip> -->
                            </div>
                        </md-table-cell>
                    </md-table-row>
                </md-table>
            </div>
            <template #footer>
                <div class="footer-dialog">
                    <vs-row>
                        <vs-col lg="6">
                            <vs-button
                                danger
                                flat
                                @click="regreshExcel()"
                                style="width: 50%"
                            >
                                Cancelar
                            </vs-button>
                        </vs-col>
                        <vs-col lg="6">
                            <vs-button
                                success
                                @click="postAceptarExcel()"
                                style="width: 50%"
                                class="ml-auto"
                            >
                                Aceptar
                            </vs-button>
                        </vs-col>
                    </vs-row>
                </div>
            </template>
        </vs-dialog>
    </div>
    
</template>
<script>
import sesiones from '../../../../../api/requests/sesiones.js'
export default {
    props:[
        'value',
        'nombreCodigo',
        'infoExcel',
        'crnId',
        'docentes',
        'allAulas'
    ],
    data () {
        return {
            active: false,
            aula: [],
            nombre_docente: '',
            apellido_paterno_docente: '',
            apellido_materno_docente: '',
            aux_nombre_docente: '',
            aux_apellido_paterno_docente: '',
            aux_apellido_materno_docente: '',
            hora_inicio: '',
            hora_fin: '',
            lunes: '',
            martes: '',
            miercoles: '',
            jueves: '',
            viernes: '',
            user: [],
            dia: [],
            dias: [
                {
                    nombre: 'lunes'
                },
                {
                    nombre: 'martes'
                },
                {
                    nombre: 'miercoles'
                },
                {
                    nombre: 'jueves'
                },
                {
                    nombre: 'viernes'
                }
            ],
            aulas:[
                {
                    id: 12,
                    text: "LABORATORIO FISICA"
                },
                {
                    id: 108,
                    text: "LABORATORIO QUIMICA"
                },
                {
                    id: 109,
                    text: "LABORATORIO BIOLOGIA"
                },
                {
                    id: 110,
                    text: "COMPUTO MIXTO"
                },

            ],
            // docentes:[
            //     {
            //         id: 5200,
            //         text: "AGUEDA PIA MADRIGAL BARBA"
            //     },
            //     {
            //         id: 5206,
            //         text: "AGUSTIN MARTINEZ CERVANTES"
            //     },
            //     {
            //         id: 5195,
            //         text: "ALEJANDRO HERRERA ROCHA"
            //     },
            //     {
            //         id: 5246,
            //         text: "ALEJANDRO SILOS SUAREZ"
            //     },
            //     {
            //         id: 5249,
            //         text: "CARLOS USIEL TORRES ROBLES"
            //     },
            //     {
            //         id: 5239,
            //         text: "GILBERTO RUEDA DOMINGUEZ"
            //     },
            //     {
            //         id: 5217,
            //         text: "JUAN ANDRES MUÑOZ MEZA"
            //     },
            //     {
            //         id: 5457,
            //         text: "MIGUEL SAUCEDO VILLALPANDO"
            //     }

            // ],
            diasId: (new Date()).getTime(),
        }
    },
    methods: {
        async postAceptarExcel(){
            const loading = this.$vs.loading()
            try{
                const info = []
                this.infoExcel.forEach((element,x) => {
                    const obj = {
                        aula_id: this.aula[x],
                        hora_fin: this.hora_fin[x],
                        hora_inicio: this.hora_inicio[x],
                        id_docente: this.nombre_docente[x],
                        id_docente_aux: this.aux_nombre_docente[x],
                    }
                    const diasSelect = []
                    if(this.dia[x].includes('lunes')){
                        diasSelect.push('l')
                    }
                    if(this.dia[x].includes('martes')){
                        diasSelect.push('m')
                    }
                    if(this.dia[x].includes('miercoles')){
                        diasSelect.push('mi')
                    }
                    if(this.dia[x].includes('jueves')){
                        diasSelect.push('j')
                    }
                    if(this.dia[x].includes('viernes')){
                        diasSelect.push('v')
                    }
                    obj.dias = diasSelect
                    info.push(obj)
                })
                const params = info
                const {data : response } = await sesiones.postAceptarExcel(this.crnId, params)
                this.$vs.notification({
                    progress: 'auto',
                    color: 'success',
                    position: null,
                    title: 'Operación éxitosa',
                    text: 'Se ha guardado correctamente la información.'
                })
                loading.close()
                this.$emit('refreshTable',true)
                this.$emit('regreshExcel')
                this.active = false
            }catch(error){
                console.log(error)
                loading.close()
                this.$vs.notification({
                    progress: 'auto',
                    color: 'success',
                    position: null,
                    title: 'Algo salio mal',
                    text: 'Favor de comunicarse con el administrador.'
                })
            }
        },
        getInfo(){
            const infoAula = []
            const infoDocente = []
            const infoAuxiliar = []
            const infoInicio = []
            const infoFin = []
            const infoDias = []
            this.infoExcel.forEach(element => {
                infoAula.push(element.aula_id)
                infoDocente.push(element.docente_id)
                infoAuxiliar.push(element.aux_docente_id)
                infoInicio.push(element.hora_inicio)
                infoFin.push(element.hora_fin)
                const dias = []
                if(element.lunes == 'si' || element.lunes == 'Si' || element.lunes == 'SI'){
                    dias.push('lunes')
                }
                if(element.martes == 'si' || element.martes == 'Si' || element.martes == 'SI'){
                    dias.push('martes')
                }
                if(element.miercoles == 'si' || element.miercoles == 'Si' || element.miercoles == 'SI'){
                    dias.push('miercoles')
                }
                if(element.jueves == 'si' || element.jueves == 'Si' || element.jueves == 'SI'){
                    dias.push('jueves')
                }
                if(element.viernes == 'si' || element.viernes == 'Si' || element.viernes == 'SI'){
                    dias.push('viernes')
                }
                infoDias.push(dias)
            });
            this.aula = infoAula
            this.nombre_docente = infoDocente
            this.aux_nombre_docente = infoAuxiliar
            this.hora_inicio = infoInicio
            this.hora_fin = infoFin
            this.dia = infoDias
        },
        regreshExcel(){
            this.active = false
            this.$emit('regreshExcel')
        }
    },
    watch: {
        value (val) {
            this.active = val
        },
        active (val) {
            if (!val){
                this.$emit('input', val);
            }
        },
        infoExcel(){
            this.getInfo()
        }
    }
}
</script>
<style lang="scss"  scoped >
.salto {
    display: block;
}

.mini-icon {
     font-size: 0.7rem !important;
}

@mixin text-colors ($theme, $text-color, $background) {
    &.col-#{$theme}{
        color: $text-color !important;
        background-color: $background !important;
    }
}

.md-chip{
    &.mini-chip{
        height: 21px;
        padding: 0px 5px;
        font-size: 12px;
        line-height: 23px;
    }
    @include text-colors ('green', #55ce63, #e8fdeb);
    @include text-colors ('none', #080808, transparent);
    @include text-colors ('red', #f62d51, #f9e7eb); 
    @include text-colors ('yellow', #febf3d, #fff8ec); 
    @include text-colors ('blue', #37aefb, #cfecfe); 
    @include text-colors ('purple', #6F3E90, #E8DAEF); 

}

label {
    margin-bottom: 0.1rem  !important;
}

.label-color {   
    @include text-colors ('green', #55ce63, #e8fdeb);
    @include text-colors ('none', #080808, transparent);
    @include text-colors ('red', #f62d51, #f9e7eb);    
}
.col-blue{
    color: #2874A6;
    background: rgb(214, 234, 248);
}
.vs-dialog__footer{
    position:absolute !important;
    bottom: 0 !important;
    width: 100% !important;
}
</style>

<style>
.excel .vs-dialog{
    width: 900px !important;
    max-width: 950px !important;
}
</style>